import React from 'react'
import classNames from 'classnames'
import './Button.scoped.sass'

export function Button (props) {
  const {
    type = 'primary',
    typeAttribute = 'button',
    size = 'regular',
    desktopSize,
    disabled,
    disabledClass,
    content,
    arrow,
    plus,
    click,
    fullWidth = true,
    fullHeight = true,
    customClass = '',
  } = props

  const onClick = () => {
    if (click) click()
  }

  return <button
    type={typeAttribute}
    className={classNames(`boxes-button ${type} ${size}`, {
      [`desk-${desktopSize}`]: desktopSize,
      disabled: disabled || disabledClass,
      'w-full': fullWidth,
      'h-full': fullHeight,
      [customClass]: customClass,
    })}
  disabled={disabled}
  onClick={onClick}
  >
    {plus
      ? <span className='plus'>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path fillRule="evenodd" clipRule="evenodd" d="M10 5a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 0 1-2 0v-3H6a1 1 0 0 1 0-2h3V6a1 1 0 0 1 1-1z" fill="currentColor"/>
        </svg>
      </span>
      : ''}
    {content}
    {arrow
      ? <span className='arrow'>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path fillRule="evenodd" clipRule="evenodd" d="M5.293 7.293a1 1 0 0 1 1.414 0L10 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414z" fill="currentColor"/>
        </svg>
      </span>
      : ''}
  </button>
}
